export enum ModulosEnum{
    CRM = 1,
    VENDAS = 2,
    CONECTA = 6,
    PORTAL_CLIENTE = 8,
    DESK = 9
}